import qs from 'qs';
import { client } from '@/client';

// function预览详情
export function getFunctionOverview(clusterName) {
  return client.get(`/api/control/function/${clusterName}/overview`);
}

export function getSinkOverview(clusterName) {
  return client.get(`/api/control/sink/${clusterName}/overview`);
}

export function getSourceOverview(clusterName) {
  return client.get(`/api/control/source/${clusterName}/overview`);
}

// function列表
export function getFunctionList(params) {
  const { clusterName, ...others } = params;
  return client.get(`/api/control/function/${clusterName}/list`, others);
}

export function getSourceList(params) {
  const { clusterName, ...others } = params;
  return client.get(`/api/control/source/${clusterName}/list`, others);
}

export function getSinkList(params) {
  const { clusterName, ...others } = params;
  return client.get(`/api/control/sink/${clusterName}/list`, others);
}

export function getFunctionChart(params) {
  const { clusterName, ...others } = params;
  return client.get(`/api/monitor/function/name/${clusterName}/`, others);
}

export function getSourceChart(params) {
  const { clusterName, ...others } = params;
  return client.get(`/api/monitor/source/name/${clusterName}/`, others);
}

export function getSinkChart(params) {
  const { clusterName, ...others } = params;
  return client.get(`/api/monitor/sink/name/${clusterName}/`, others);
}

// 创建Function任务
export function createFunction(params) {
  return client.post('/api/control/function/addFunction', params);
}

// 创建Source任务
export function createSource(params) {
  return client.post('/api/control/source/addSource', params);
}

// 创建Sink任务
export function createSink(params) {
  return client.post('/api/control/sink/addSink', params);
}

// 删除function
export function removeFunction(params) {
  return client.delete('/api/control/function/deleteFunction', params);
}

export function removeSource(params) {
  return client.delete('/api/control/source/deleteSource', params);
}

export function removeSink(params) {
  return client.delete('/api/control/sink/deleteSink', params);
}

// Function详情
export function getFunctionDetail(params) {
  return client.get('/api/control/function/getFunctionDetail', params);
}

// Source详情
export function getSourceDetail(params) {
  return client.get('/api/control/source/getSourceDetail', params);
}

export function getSinkDetail(params) {
  return client.get('/api/control/sink/getSinkDetail', params);
}

// 更新详情
export function updateFunctionNote(params) {
  return client.post(
    `/api/control/function/updateFunctionNote${qs.stringify(params, { addQueryPrefix: true })}`,
  );
}

// 实例列表
export function getFunctionInstances(params) {
  return client.get('/api/control/function/getFunctionInstanceDetail', params);
}

// 实例列表source
export function getSourceInstances(params) {
  return client.get('/api/control/source/getSourceInstanceDetail', params);
}

// 实例列表sink
export function getSinkInstances(params) {
  return client.get('/api/control/sink/getSinkInstanceDetail', params);
}

// 包管理列表
export function getPackageList(params) {
  return client.get('/api/control/package/getFunctionPackages', params);
}

// 包上传
export function uploadPackage(params) {
  return client.form('/api/control/package/packagesUpload', params);
}

// 删除包
export function deletePackageByVersion(params) {
  return client.delete('/api/control/package/deletePackageByVersion', params);
}

// 配置详情
export function getFunctionConfigDetail(params) {
  return client.get('/api/control/function/getFunctionConfigDetail', params);
}

export function getSinkConfigDetail(params) {
  return client.get('/api/control/sink/getSinkConfigDetail', params);
}

export function getSourceConfigDetail(params) {
  return client.get('/api/control/source/getSourceConfigDetail', params);
}

export function updateFunctionConfig(params) {
  const { clusterName, ...others } = params;
  return client.post(`/api/control/function/updateFunction?clusterName=${clusterName}`, others);
}

export function updateSinkConfig(params) {
  const { clusterName, ...others } = params;
  return client.post(`/api/control/sink/updateSink?clusterName=${clusterName}`, others);
}

export function updateSourceConfig(params) {
  const { clusterName, ...others } = params;
  return client.post(`/api/control/source/updateSource?clusterName=${clusterName}`, others);
}

export function doFunctionRestart(params) {
  const { clusterName, functionName } = params;
  return client.put(
    `/api/control/function/restartFunction?clusterName=${clusterName}&functionName=${functionName}`,
  );
}

export function doFunctionStop(params) {
  const { clusterName, functionName } = params;
  return client.put(
    `/api/control/function/stopFunction?clusterName=${clusterName}&functionName=${functionName}`,
  );
}
export function doSinkRestart(params) {
  const { clusterName, sinkName } = params;
  return client.put(
    `/api/control/sink/restartSink?clusterName=${clusterName}&sinkName=${sinkName}`,
  );
}

export function doSinkStop(params) {
  const { clusterName, sinkName } = params;
  return client.put(`/api/control/sink/stopSink?clusterName=${clusterName}&sinkName=${sinkName}`);
}

export function doSourceRestart(params) {
  const { clusterName, sourceName } = params;
  return client.put(
    `/api/control/source/restartSource?clusterName=${clusterName}&sourceName=${sourceName}`,
  );
}

export function doSourceStop(params) {
  const { clusterName, sourceName } = params;
  return client.put(
    `/api/control/source/stopSource?clusterName=${clusterName}&sourceName=${sourceName}`,
  );
}

export function getFunctionStatus(params) {
  return client.get('/api/control/function/getFunctionStatus', params);
}

export function getFunctionParams(params) {
  return client.get('/api/control/function/getFunctionRuntimeConfig', params);
}

export function getSourceStatus(params) {
  return client.get('/api/control/source/getSourceStatus', params);
}

export function getSourceParams(params) {
  return client.get('/api/control/source/getSourceRuntimeConfig', params);
}

export function getSinkStatus(params) {
  return client.get('/api/control/sink/getSinkStatus', params);
}

export function getSinkParams(params) {
  return client.get('/api/control/sink/getSinkRuntimeConfig', params);
}

// 校验token权限
export function checkFunctionAuthRole(params) {
  return client.post('/api/control/function/checkFunctionAuthRole', params);
}
